export default __webpack_public_path__ + "assets/img/favicon.9c8965c.png";